import {
    addDays,
    isAfter,
    isSameDay,
    isSaturday,
    isSunday,
    isWeekend,
    setHours,
    setMinutes,
    setSeconds,
} from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import DateHolidays, { Holiday } from 'date-holidays';
import { injectable } from 'tsyringe';
import { MARKET_TIMEZONE } from '../constants/tokens';
import { MarketStatus } from '../types/Market.type';
import { IMarketApi } from './interfaces/IMarketApi';

@injectable()
export class MarketApi implements IMarketApi {
    getMarketStatus(): MarketStatus {
        const now = new Date(Date.now());

        let openTime = new Date(now);
        openTime = setHours(openTime, 9);
        openTime = setMinutes(openTime, 30);
        openTime = setSeconds(openTime, 0);
        openTime = zonedTimeToUtc(openTime, MARKET_TIMEZONE);

        let closeTime = new Date(now);
        closeTime = setHours(closeTime, 16);
        closeTime = setMinutes(closeTime, 0);
        closeTime = setSeconds(closeTime, 0);
        closeTime = zonedTimeToUtc(closeTime, MARKET_TIMEZONE);

        let opening = false;
        let holiday = '';
        let until = new Date(openTime);

        const holidays = new DateHolidays('US', { types: ['public'], timezone: MARKET_TIMEZONE });

        // the lib is missing Good Friday
        holidays.setHoliday('easter -2', {
            name: {
                en: 'Good Friday',
            },
            type: 'public',
        });

        const excludedHolidaysFilter = (holiday: Holiday) =>
            !holiday.name.startsWith('Columbus') && !holiday.name.startsWith('Veterans');

        if (!isWeekend(now)) {
            let todayHoliday = holidays.isHoliday(now);
            if (todayHoliday) {
                todayHoliday = todayHoliday.filter(excludedHolidaysFilter);
            }

            if (todayHoliday && todayHoliday.length) {
                for (const day of todayHoliday) {
                    until = addDays(until, 1);
                    holiday = day.name;
                }
            } else if (isAfter(now, openTime) && isAfter(now, closeTime)) {
                until = addDays(until, 1);
            } else if (isAfter(now, openTime)) {
                until = closeTime;
                opening = true;
            }
        } else {
            until = addDays(until, 1);
        }

        if (!opening) {
            if (isSaturday(until)) {
                until = addDays(until, 2);
            }

            if (isSunday(until)) {
                until = addDays(until, 1);
            }

            holidays
                .getHolidays(now.getFullYear())
                .filter(excludedHolidaysFilter)
                .forEach((day) => {
                    if (isSameDay(utcToZonedTime(until, MARKET_TIMEZONE), utcToZonedTime(day.start, MARKET_TIMEZONE))) {
                        until = addDays(until, 1);
                        holiday = day.name;
                    }
                });
        }

        return {
            until: until.getTime(),
            opening,
            reason: holiday,
        };
    }
}
